import {AlpineComponent} from 'alpinejs';

type TabData = {}

export default (): AlpineComponent<TabData> => ({
  init() {
    const tabContent = this.$refs.content;
    const tabEls = document.querySelectorAll('button[data-bs-toggle="pill"]');
    if (tabContent && tabEls) {
      tabEls.forEach(tabEl => {
        if (tabEl) {
          tabEl.addEventListener('shown.bs.tab', () => {
            window.scrollTo(0, tabContent.offsetTop - 300);
          });
        }
      });
    }
  }
});
